import { useHistory } from "react-router-dom"
import { useGetPedidoById } from "../data/api/gestao/pedido/get-pedido-by-id"
import { usePutAlterarStatusPedido } from "../data/api/gestao/pedido/put-alterar-status-pedido"
import { usePutPedidoDados } from "../data/api/gestao/pedido/put-pedido-dados"
import { PedidoDadosModelPut, PedidoDadosPagamentoModel } from "../model/api/pedidos/pedido-dados-model"
import { PedidoModel } from "../model/api/pedidos/pedido-model"
import { EnumStatusPedidoLocal } from "../model/enums/enum-status-pedido-local"
import { useKdsToken, useSessaoAtual, useToastSaurus } from "../services/app"
import { guidEmpty } from "../utils/guid-empty"
import { picker } from "../utils/picker"
import { useGetLocalizacaoUsuario } from "../data/api/localizacao/get-localizacao-usuario"
import { useState } from "react"
import { PedidoDadosEntrega } from "../model/api/pedidos/pedido-dados-entrega"

export const usePedidos = () => {
    const { getPedidoById, carregando: carregandoGetPedido } = useGetPedidoById()
    const { putAlterarStatusPedido, carregando: carregandoPostStatus } = usePutAlterarStatusPedido()
    const { putPedidoDados, carregando: carregandoPostPedido } = usePutPedidoDados()
    const { obterLocalizacao } = useGetLocalizacaoUsuario()
    const [carregandoInterno, setCarregandoInterno] = useState(false)

    const carregando = carregandoGetPedido || carregandoPostStatus || carregandoPostPedido || carregandoInterno;

    const { getPessoaUsuario } = useKdsToken()
    const { getEmpresaSelecionada } = useSessaoAtual()
    const { showToast } = useToastSaurus()
    const history = useHistory()

    const formatToPedidoDadosPut = (pedido: PedidoModel) => {
        const pagamentos: PedidoDadosPagamentoModel[] = pedido.pagamentos.map(pag => {
            return {
                ...pag,
                tpMod: pag.tpMod.codigo,
                situacao: pag.situacao.codigo,
            }
        })
        const pedidoPicker = picker<PedidoDadosModelPut>(pedido, new PedidoDadosModelPut())
        const pedidoModel: PedidoDadosModelPut = {
            ...pedidoPicker,
            cliente: pedido.cliente,
            enderecoEntrega: pedido.enderecoEntrega,
            statusAutomacao: pedido.statusAutomacao.codigo,
            statusPedido: pedido.statusPedido.codigo,
            tipoPedido: pedido.tipoPedido.codigo,
            pagamentos,
        }

        return pedidoModel
    }

    const searchPedido = async (pedidoId: string) => {
        const pedidoApi = await getPedidoById(getEmpresaSelecionada()?.Id!, pedidoId);
        if (pedidoApi.erro) throw pedidoApi.erro;

        const pedido = pedidoApi.resultado?.data;
        if (!pedido) throw new Error('Pedido não encontrado.');
        return pedido
    }

    const alterarEntregadorPedido = async (pedido: PedidoModel, alterarStatus: boolean = false) => {
        const pessoa = getPessoaUsuario().pessoa;
        pedido.entregadorId = pessoa.id;
        pedido.entregadorNome = pessoa.nome
        const pedidoDados = formatToPedidoDadosPut(pedido);
        const res = await putPedidoDados(getEmpresaSelecionada()?.Id!, pedidoDados);
        if (res.erro) throw res.erro;
        if (alterarStatus) {
            const res = await putAlterarStatusPedido(getEmpresaSelecionada()?.Id!, pedido.id, EnumStatusPedidoLocal.ENVIADO);
            if (res.erro) throw res.erro;
        }
    }

    const alterarStatusPedidoEntregador = async (codigo: string, alterarStatus: boolean = true) => {
        try {
            const idPedido = codigo.includes('/') ? codigo.split('/').pop()! : codigo;

            const pedido = await searchPedido(idPedido);
            debugger
            if (pedido.entregadorId === getPessoaUsuario().pessoa.id) {
                throw new Error('Este pedido já está vinculado a você.')
            } else {
                if (pedido.entregadorId && pedido.entregadorId !== guidEmpty()) throw new Error('Este pedido já está com outro entregador.')

                await alterarEntregadorPedido(pedido);
            }
            if (alterarStatus) {
                const res = await putAlterarStatusPedido(getEmpresaSelecionada()?.Id!, idPedido, EnumStatusPedidoLocal.ENVIADO);
                if (res.erro) throw res.erro;
            }

            showToast('success', 'Status do pedido alterado para ENVIADO.');
            return true
        }
        catch (err: any) {
            showToast('error', err.message);
            return false
        }
    }

    const concluirPedidoEntrega = async (pedidoId: string, assinatura?: string) => {
        try {
            setCarregandoInterno(true)
            const localizacao = await obterLocalizacao()
            const pedidoDadosEntrega: PedidoDadosEntrega = {
                imagemDados: assinatura ?? '',
                ...localizacao,
            }
            const res = await putAlterarStatusPedido(getEmpresaSelecionada()?.Id!, pedidoId, EnumStatusPedidoLocal.FECHADO, pedidoDadosEntrega);
            if (res.erro) throw res.erro;
            history.push('/');
            showToast('success', 'Pedido entregue com sucesso!');
            return true
        } catch (err: any) {
            showToast('error', err.message);
            return false
        } finally {
            setCarregandoInterno(false)
        }
    }

    return {
        carregando: carregando,

        formatToPedidoDadosPut,
        alterarStatusPedidoEntregador,
        alterarEntregadorPedido,
        searchPedido,
        concluirPedidoEntrega,
    }
}